
(function () {
    document.addEventListener('DOMContentLoaded', function () {

        var $anchorNav = document.querySelector('.anchor-nav');
        var $body = document.querySelector('body');
        var $eyebrowSubmenuToggles = document.querySelectorAll('.header-eyebrow-item:has(.header-nav-link--dropdown)');
        var $header = document.querySelector('.header');
        var $headerToggle = document.querySelector('.header-nav-toggle');
        var $navLinks = document.querySelectorAll('.header-nav-link');
        var $navItem = document.querySelectorAll('.header-nav-item');
        var $navSubmenuToggle = document.querySelectorAll('.header-nav-link--dropdown');

        var prevScrollY = window.scrollY;

        if (!$header) {
            return;
        }

        resetActiveNavLink();
        setTimeout(init, 200);

        window.addEventListener('resize', _debounce(onResize, 200));
        window.addEventListener('scroll', _debounce(onScroll, 0, true));

        $headerToggle.addEventListener('click', toggleHeaderNav);

        ////

        function init() {
            $header.classList.remove('collapsed');

            translateAnchorNav('remove');

            for (let index = 0; index < $navSubmenuToggle.length; index++) {
                $navSubmenuToggle[index].addEventListener('click', onClickSumenuToggle);
            }

            for (let index = 0; index < $eyebrowSubmenuToggles.length; index++) {
                $eyebrowSubmenuToggles[index].addEventListener('mouseenter', onMouseSubmenuToggle);
                $eyebrowSubmenuToggles[index].addEventListener('mouseleave', onMouseSubmenuToggle);
            }
        }

        function onClickSumenuToggle(event) {
            var $toggle = event.currentTarget;

            var $navItem = $toggle.closest('.header-nav-item');
            var $submenu = $navItem.querySelector('.header-eyebrow-sublist');

            if (!_isMobile() || !$submenu) {
                return;
            }

            event.preventDefault();

            $submenu.classList.toggle('active');
            $toggle.classList.toggle('active');
        }

        function onMouseSubmenuToggle(event) {
            var $toggle = event.currentTarget;

            var $navLink = $toggle.querySelector('.header-nav-link--dropdown');
            var $submenu = $toggle.querySelector('.header-eyebrow-sublist');

            if (_isMobile() || !$navLink) {
                return;
            }

            let method = $navLink.classList.contains('active') ? 'remove' : 'add';

            $navLink.classList[method]('active');
            $submenu.classList[method]('active');
        }

        function onResize() {
            $header.classList.remove('collapsed');

            toggleHeaderNav({}, true);
        }

        function onScroll(methodOverride) {
            var currScrollY = window.scrollY;

            var delta = Math.abs(currScrollY - prevScrollY);
            var method = currScrollY > 150 && currScrollY >= prevScrollY ? 'add' : 'remove';

            if (methodOverride == 'add' || methodOverride == 'remove') {
                method = methodOverride;
            }

            if (window.anchorNavToggling) {
                return;
            }

            if (window.anchorNavScrolling) {
                delta = 100;
                method = 'add';
            }

            prevScrollY = currScrollY;

            if (delta < 50 && delta > -50 && currScrollY > 100) {
                return;
            }

            $header.classList[method]('collapsed');

            if ($anchorNav) {
                setTimeout(() => translateAnchorNav(method), 200);
            }
        }

        function resetActiveNavLink() {
            var pathname = window.location.pathname.replace(/\/$/, '');

            for (let i = 0; i < $navLinks.length; i++) {
                let href = $navLinks[i].getAttribute('href').replace(/\/$/, '');

                $navLinks[i].classList.remove('active');

                if (href === pathname) {
                    $navLinks[i].classList.add('active');

                    // Show dropdown mobile submenu when child nav item is active
                    if ($body.offsetWidth < 1200) {
                        var submenu = $navLinks[i].closest('.header-nav-submenu');
                        var dropdown = $navLinks[i].closest('.header-nav-item.dropdown');

                        if (dropdown && submenu) {
                            submenu.classList.add('show');
                            dropdown.classList.add('show');
                        }
                    }

                } else if ((pathname === '/safety' || pathname === '/efficacy') && href === '#') {
                    var parentItem = $navLinks[i].closest('.header-nav-item');
                    var hasEfficacyOrSafety = parentItem && (
                        parentItem.querySelector('a[href="/efficacy/"]') ||
                        parentItem.querySelector('a[href="/safety/"]')
                    );

                    if (hasEfficacyOrSafety) {
                        $navLinks[i].classList.add('active');
                    }
                }
            }
        }

        function toggleHeaderNav(event, toggleOff) {
            var isActive = $header.classList.contains('mobile-nav-active');

            $body.classList.remove('overflow-hidden');
            $header.classList.remove('mobile-nav-active');

            if (!_isMobile() || isActive || toggleOff) {
                return;
            }

            $body.classList.add('overflow-hidden');
            $header.classList.add('mobile-nav-active');
        }

        function translateAnchorNav(method) {
            var headerHeight = method === 'remove' ? $header.offsetHeight : 0;
            var translateY = 0;
            var stuckMethod = window.scrollY > 400 ? 'add' : 'remove';

            if (window.scrollY > 400) {
                translateY = headerHeight + 'px';
            }

            if (!$anchorNav) {
                return;
            }

            $anchorNav.classList[stuckMethod]('stuck');

            $anchorNav.style.transform = 'translateY(' + translateY + ')';
        }

        ////

        function _debounce(func, wait, immediate) {
            var timeout;

            return function () {
                var callNow = immediate && !timeout;
                var context = this, args = arguments;

                clearTimeout(timeout);

                timeout = setTimeout(later, wait);

                if (callNow) func.apply(context, args);

                function later() {
                    timeout = null;

                    if (immediate) return;

                    func.apply(context, args);
                }
            };
        }

        function _isMobile() {
            return $body.offsetWidth < 1200;
        }

    });
})();

(function ($) {
    $(function () {

        var $navTarget = $('#anchorNavDropdown');
        var $navToggle = $('[aria-controls="anchorNavDropdown"]');

        var $navLinks = $navTarget.find('.nav-link');

        if (!$navToggle.length || !$navLinks.length) {
            return;
        }

        $navLinks.on('click', onClickLink);
        $navToggle.on('click', onClickToggle);

        function onClickLink(event) {
            var id = event.currentTarget.getAttribute('href');

            var $target = $(id);

            if (!$target.length) {
                return;
            }

            event.preventDefault();

            // Update the URL hash without navigating away
            if (history.pushState) {
                history.pushState(null, null, id);
            } else {
                location.hash = id;
            }

            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $target.offset().top - 60
                }, 200);
            }, 200);

            window.anchorNavScrolling = true;

            $navTarget.collapse('hide');

            setTimeout(function () {
                window.anchorNavScrolling = false;
            }, 1000);
        }

        function onClickToggle(event) {
            var method = $navTarget.hasClass('show') ? 'removeClass' : 'addClass';

            window.anchorNavToggling = true;

            event.preventDefault();

            $navTarget.collapse('toggle');
            $navToggle[method]('expanded');

            setTimeout(function () {
                window.anchorNavToggling = false;
            }, 1000);
        }

    });
})(jQuery);


// On mobile, when a parent menu item is clicked, toggle the submenu instead of navigating to the link
(function ($) {
    $(function () {
        var $menuItems = $('.header-nav-item');

        $menuItems.on('click', function (event) {
            if ($(window).width() >= 1200) {
                return;
            }

            var $submenu = $(this).find('.header-nav-submenu');

            if ($submenu.length) {
                // event.preventDefault();
                $submenu.toggleClass('show');
                $submenu.toggleClass('noshow');

                // also add show to the parent item to keep it open
                $(this).toggleClass('show');
                $(this).toggleClass('noshow');
            }
        });
    });
})(jQuery);